module.exports = __webpack_public_path__ + "img/Mao.05ed8cb7.png";